// frontend/src/pages/Imprint.js

import React from 'react';
import { motion } from 'framer-motion';

const Imprint = () => {
  return (
    <motion.div
      className="min-h-screen bg-gradient-to-b from-white to-gray-50 py-12 px-4"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-2xl mx-auto bg-white rounded shadow-md p-8">
        <h1 className="text-3xl font-heading text-primary mb-6">Impressum</h1>

        <p className="mb-4 text-gray-700">
          <strong>Klassenprojekt S3b</strong>
          <br />
          Schule Oberentfelden
          <br />
          5036 Oberentfelden
          <br />
          Schweiz
        </p>

        <p className="mb-4 text-gray-700">
          <strong>Kontakt:</strong>
          <br />
          <a href="mailto:info@entecity.ch" className="text-blue-600 underline">
            info@entecity.ch
          </a>
          <br />
          Telefon Nr: +41 79 660 51 51
        </p>

        <p className="mb-4 text-gray-700">
          <strong>Vertreten durch:</strong>
          <br />
          Klassenlehrperson M. Schumacher
        </p>

        <p className="mb-4 text-gray-700">
          <strong>Haftungsausschluss:</strong>
          <br />
          Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
          für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
          sind ausschliesslich deren Betreiber verantwortlich.
        </p>

        <p className="mb-4 text-gray-700">
          <strong>Copyright-Hinweis:</strong>
          <br />
          Alle Inhalte (Texte, Bilder, Grafiken, etc.) auf dieser Website sind
          urheberrechtlich geschützt. Jede Verwertung ausserhalb der engen
          Grenzen des Urheberrechtsgesetzes ist ohne Zustimmung des jeweiligen
          Autors unzulässig. Dies gilt insbesondere für Vervielfältigung,
          Bearbeitung, Übersetzung, Einspeicherung, Verarbeitung bzw. Wiedergabe
          von Inhalten in Datenbanken oder anderen elektronischen Medien und
          Systemen.
        </p>
      </div>
    </motion.div>
  );
};

export default Imprint;
